import { createApi } from "@reduxjs/toolkit/query/react";
import axiosLoginBaseQuery from "./axiosLoginBaseQuery";
import { appEnv } from "../appEnv";

const apiLogin = createApi({
    reducerPath: 'apiLogin',
    baseQuery: axiosLoginBaseQuery(appEnv.CONFIGURADOR_BASEURL),
    endpoints: () => ({}),
    tagTypes: ['USER']
})

export default apiLogin